module.exports = __webpack_public_path__ + "79b018b9c0339c36222f2f88966dda3f.svg";